<app-loader [Parent]="this"></app-loader>
@if (FormLoaded == true) {
  <div [formGroup]="Form">
    <app-pageheader [Parent]="this">
    </app-pageheader>
    <!-- <app-validationsummary [Form]="Form"></app-validationsummary> -->
    <div class="columns">
      <div class="column is-half">
        @if (this.Model != null) {
          <article class="panel">
            <p class="panel-heading">Session <span class="has-bold-text">#{{this.Model.Id}}</span> ({{Model.Status}})</p>
            <div class="panel-block">
              <span class="label">Plate Number</span>
              <span class="value">{{Model.PlateNumbers}}</span>
            </div>
            @if (Model.EntryPlateMediaId != null || Model.ExitPlateMediaId != null) {
              <div class="panel-block">
                <span class="label">Snapshots</span>
                <span class="value">
                  @if (this.Model.EntryPlateMediaId != null) {
                    <app-media-thumbnail [MediaId]="this.Model.EntryPlateMediaId" Title="Entry Plate Read"  ModalImageWidth="480px" ModalImageHeight="300px" ThumbnailHeight="36px" ThumbnailWidth="48px"></app-media-thumbnail>
                    }&nbsp;&nbsp;
                    @if (this.Model.ExitPlateMediaId != null) {
                      <app-media-thumbnail [MediaId]="this.Model.ExitPlateMediaId" Title="Exit Plate Read" ModalImageWidth="480px" ModalImageHeight="300px" ThumbnailHeight="36px" ThumbnailWidth="48px"></app-media-thumbnail>
                    }
                  </span>
                </div>
              }
              @if (Model.ControlledAreaId != null) {
                <div class="panel-block">
                  <span class="label">Area</span>
                  <span class="value">{{Model.ControlledAreaName}}</span>
                </div>
              }
              @if (Model.ParkingLotId != null) {
                <div class="panel-block">
                  <span class="label">Parking Lot</span>
                  <span class="value">{{Model.ParkingLotName}}</span>
                </div>
              }
              @if (this.Model.OrganizationUser != null) {
                <a class="panel-block">
                  <span class="label">User</span>
                  <span class="value"><a
                    routerLink="/usermanagement/users/{{Model.OrganizationUserId}}">{{Model.OrganizationUser.FirstName}}
                  {{Model.OrganizationUser.LastName}} ({{Model.OrganizationUser.Email}})</a></span>
                </a>
              }
              @if (Model.ControlledAreaId != null) {
                <div class="panel-block">
                  <span class="label">Entry</span>
                  @if (Model.ControlledAreaEntryDateLocalString != '') {
                    <span class="value">
                      {{ ValueFollowedByComma(Model.EntryLaneName) }}
                      {{Model.ControlledAreaEntryDateLocalString}}
                    </span>
                  }
                </div>
              }
              @if (Model.ControlledAreaId != null) {
                <div class="panel-block">
                  <span class="label">Exit</span>
                  @if (Model.ControlledAreaExitDateLocalString != '') {
                    <span class="value">
                      {{ ValueFollowedByComma(Model.ExitLaneName) }}
                      {{Model.ControlledAreaExitDateLocalString}}
                    </span>
                  }
                  @if (!Model.ControlledAreaExitDateLocalString && Model.Status === 'Open') {
                    <span class="button is-primary"
                      (click)="CloseSession()">
                      Close Session
                    </span>
                  }
                </div>
              }
              @if (Model.ParkingSpaceId != null) {
                <div class="panel-block">
                  <span class="label">Parking Space</span>
                  <span class="value">{{Model.ParkingSpaceName}}</span>
                </div>
              }
              @if (Model.ParkingSpaceId != null) {
                <div class="panel-block">
                  <span class="label">Parked At</span>
                  <span class="value">{{Model.ParkingSpaceEntryDateLocalString}}</span>
                </div>
              }
              @if (Model.ParkingSpaceId && !Model.ControlledAreaId) {
                <div class="panel-block">
                  <span class="label">Departed at</span>
                  <span class="value">{{Model.ParkingSpaceExitDateLocalString ?? "unknown"}}</span>
                  @if (Model.ParkingSpaceExitDateLocalString == '' && Model.Status === 'Open') {
                    <span class="button is-primary"
                    (click)="CloseSession()">Close Session</span>
                  }
                </div>
              }
              <div class="panel-block">
                <span class="label">Duration</span>
                <span class="value">{{Model.DurationAsString}}</span>
              </div>
              <div class="panel-block">
                <span class="label">Rate Set</span>
                <span class="value">
                  {{Model.ParkingRateSetName}}
                  <a class="fa fa-pencil is-primary ml-3" (click)="ChangeRateSet()" tippy="Change the Rate Set for this session"></a>
                </span>
              </div>
              @if (Model.DiscountTypeId != null) {
                <div class="panel-block">
                  <span class="label">Discount Applied</span>
                  <span class="value">
                    {{Model.DiscountTypeName}}
                    @if (Model.ModifierCodeId != null) {
                      <span>(Code {{Model.DiscountCode}})</span>
                    }
                  </span>
                </div>
              }
              <div class="panel-block">
                <span class="label">Fee</span>
                <span class="value">
                  {{this.Model.QuotedAmount | currency:'USD':true:'1.2-2'}}
                  @if (Model.ValidationUserId != null) {
                    <span>
                      (validated by {{Model.ValidationUser?.Name}})
                    </span>
                  }
                </span>
              </div>
              @if (this.Model.ParkingPermitInstance?.ParkingPermit != null) {
                <a class="panel-block">
                  <span class="label">Parking Permit</span>
                  <span class="value">
                    <a [routerLink]="PermitDetailsRoute()">
                      {{Model.ParkingPermitInstance.ParkingPermit.ParkingPermitType.Name}}
                      @if (!IsHotelReservationPermit()) {
                        <span>({{Model.ParkingPermitInstance.ParkingPermit.UserCount}} users, {{Model.ParkingPermitInstance.ParkingPermit.TimesUsed}} uses)</span>
                      }
                    </a>
                  </span>
                </a>
              }
              <div class="panel-block">
                <span class="label">Paid</span>
                <span class="value">
                  {{this.Model.TotalPaid | currency:'USD':true:'1.2-2'}}
                  <a class="fas fa-plus is-primary ml-3" (click)="MakeManualPayment()" tippy="Record a payment against this session"></a>
                </span>
              </div>
            </article>
          }
        </div>
        <div class="column is-half">
          <app-structureviewermaps [Layers]="StructureViewerLayers" [SearchTerm]="StructureSearchTerm"
          [StructureId]="StructureId" [StructureViewerForType]="StructureViewerForType"></app-structureviewermaps>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <article class="panel">
            <p class="panel-heading">
              Session Payments
            </p>
            <a class="panel-block">
              <table class="table is-striped">
                <thead>
                  <tr>
                    @for (h of Columns; track h) {
                      <th>{{h.Header}}</th>
                    }
                    <th class="buttoncolumn"></th>
                    <th class="buttoncolumn"></th>
                  </tr>
                </thead>
                @if (this.Model.Payments != null && this.Model.Payments.length > 0) {
                  <tbody>
                    @for (p of this.Model.Payments; track p) {
                      <tr>
                        <td>{{p.IsHold ? "Hold Charge (Incomplete)" : p.AccountTransactionId}}</td>
                        <td>{{p.Amount}}</td>
                        <td>{{p.PaidFromLocalString}}</td>
                        <td>{{p.IsHold ? "" : p.PaidToLocalString}}</td>
                        <td>{{p.PaymentType}}</td>
                        <td>{{p.TransactionId}}</td>
                        <td>{{p.TransactionReference}}</td>
                        @if (!p.TransactionReference?.includes('Refund') && p.Amount > 0 && !p.IsHold) {
                          <td>
                            <button class="button is-primary is-small" (click)="RecordRefund(p)">
                              <span>Record Refund</span>
                            </button>
                          </td>
                        }
                        @if (!p.TransactionReference?.includes('Refund') && !p.IsHold) {
                          <td>
                            <button class="button is-primary is-small" (click)="Receipt(p)">
                              <span>Receipt</span>
                            </button>
                          </td>
                        }
                      </tr>
                    }
                  </tbody>
                }
                <tbody>
                  @if (this.Model.Payments == null || this.Model.Payments.length == 0) {
                    <tr>
                      <td><i>No Payments</i></td>
                    </tr>
                  }
                </tbody>
              </table>
            </a>
          </article>
        </div>
      </div>
    </div>
  }
